<template>
    <div id="Ep-pop" class="My_popup" style="display: block;">
        <div class="My_popup_wrap">
            <span class="My_popup_close" href="#" @click.prevent="closeClickHandler" style="cursor: pointer;">닫기</span>
            <div class="My-popup-title">{{ governanceInfo.val2 }}</div>
            <div class="ep-photo pink-line">
                <span class="flag pink">협치</span>
                <div class="pop-picture-wrap">
                    <swiper class="swiper" :options="swiperOption">
                        <swiper-slide v-for="(image, i) in governanceInfo.dataFiles" :key="i">
                            <ul class="slides">
                                <img :src="getImgUrl(image)" @error="altImgUrl" :alt="image.otxtFlnm">
                            </ul>
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                </div>
            </div>
            <div class="My-popup-content">
                <div class="ep-detail">
                    <div class="ep-list bdr-bm">
                        <ul>
                            <li>
                                <span>사업명</span>
                                <span>{{ governanceInfo.val2 }}</span>
                            </li>
                            <li>
                                <span>사업소개</span>
                                <span v-html="governanceInfo.val7"></span>
                            </li>
                            <li>
                                <span>소요예산</span>
                                <span>{{ governanceInfo.val4 }}</span>
                            </li>
                            <li>
                                <span>주소</span>
                                <span>{{ governanceInfo.val6 }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="pop_title">사업상세</div>
                    <div class="pop_table bdr-bm">
                        <table class="tb-list02" summary="추진경과">
                            <caption>추진경과 내역</caption>
                            <colgroup>
                                <col style="width:20%">
                                <col style="width:80%">
                            </colgroup>
                            <tr>
                                <th>사업개요</th>
                                <td class="alignL" v-html="$options.filters.newLineToBr(governanceInfo.val3)"></td>
                            </tr>
                            <tr>
                                <th>비고</th>
                                <td class="alignL" v-html="$options.filters.newLineToBr(governanceInfo.val5)"></td>
                            </tr>
                        </table>
                    </div>
                    <!-- <GovernanceRelevantBizFoundInfoList :governanceFoundInfo="governanceInfo" :diagName="diagName" /> 
                    <div class="bdr-bm"></div> -->
                    <!-- <div class="pop_title">여론동향</div>
                    <NewsDataList :paramObj="paramObj" /> -->

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { $WC } from '@/conf/common.const.js';
import GovernanceRelevantBizFoundInfoList from '@/views/biz/GovernanceRelevantBizFoundInfoList.vue';
import NewsDataList from '@/components/NewsDataList.vue';

export default {
    name: 'governanceFoundInfoWin',
    props: {
        paramObj: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 1,
                spaceBetween: 30,
                autoplay: {
                    delay: $WC.FIVE_SEC_INTERVAL,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            },
            selectedPromiseCategoryCode: "A",
            promiseBusinessDatas: [],
            diagName: '협치'
        }
    },
    created() {
        this.$store.dispatch('FETCH_PROMISE_INFO', this.paramObj)
    },
    computed: {
        governanceInfo() {
            return this.$store.getters.getPromiseInfo;
        },
    },
    mounted() {
    },
    methods: {
        closeClickHandler() {
            this.$emit("close-governance-info-win");
        },
        getImgUrl(image) {
            if (typeof image.comnFlSqno !== 'undefined') {
                return $WC.apiBaseURL + '/data/image/' + image.comnFlSqno;
            } else {
                return $WC.cp + 'images/none_img.png';
            }
        },
        altImgUrl(event) {
            event.target.src = $WC.cp + 'images/none_img.png';
        },
    },
    components: {
        GovernanceRelevantBizFoundInfoList,
        NewsDataList
    }
}
</script>